(function () {
  "use strict";

  const SELECTORS = {
    config: "[data-algolia-config]",
    container: "[data-algolia-search-results]",
    grid: "[data-algolia-search-grid]",
    loading: "[data-algolia-search-loading]",
    empty: "[data-algolia-search-empty]",
    pagination: "[data-algolia-search-pagination]",
    count: "[data-algolia-results-count]",
    countMobile: "[data-algolia-results-count-mobile]",
    sortDropdowns: "[data-algolia-sort-dropdown]",
    filtersToggle: "[data-algolia-filters-toggle]",
    filtersDrawer: "[data-algolia-filters-drawer]",
    filtersBackdrop: "[data-algolia-filters-backdrop]",
    filtersClose: "[data-algolia-filters-close]",
    filtersBody: "[data-algolia-filters-body]",
    filtersApply: "[data-algolia-filters-apply]",
    filtersReset: "[data-algolia-filters-reset]",
  };

  const FACET_ATTRIBUTES = ["options.größe", "product_type"];
  const productSkuCache = new Map();
  let etrustedObserver = null;

  function init() {
    const configEl = document.querySelector(SELECTORS.config);
    const container = document.querySelector(SELECTORS.container);
    if (!configEl || !container) return;

    const appId = configEl.getAttribute("data-algolia-app-id");
    const apiKey = configEl.getAttribute("data-algolia-api-key");
    const indexPrefix =
      configEl.getAttribute("data-algolia-index-prefix") || "shopify_";
    const moneyFormat =
      configEl.getAttribute("data-money-format") || "{{amount}} €";
    const locale = configEl.getAttribute("data-locale") || "de";
    const rootUrl = configEl.getAttribute("data-root-url") || "/";

    const translationsScript = document.querySelector(
      "[data-algolia-translations-json]",
    );
    const translations = translationsScript
      ? JSON.parse(translationsScript.textContent)
      : {};

    if (!appId || !apiKey) return;

    const productsIndex =
      locale === "de"
        ? `${indexPrefix}products`
        : `${indexPrefix}products_deutschland_en`;

    const sortIndices = {};
    const sortKeys = [
      "best-selling",
      "alpha-asc",
      "alpha-desc",
      "price-asc",
      "price-desc",
      "date-asc",
      "date-desc",
    ];
    sortKeys.forEach((key) => {
      const value = configEl.getAttribute(`data-algolia-sort-${key}`);
      if (value) sortIndices[key.replace(/-/g, "_")] = value;
    });

    const defaultSort =
      configEl.getAttribute("data-algolia-default-sort") || "best_selling";
    let currentSort = getQueryParam("sort_by") || defaultSort;

    const hitsPerPage =
      parseInt(container.getAttribute("data-hits-per-page"), 10) || 12;

    const grid = container.querySelector(SELECTORS.grid);
    const loading = container.querySelector(SELECTORS.loading);
    const empty = container.querySelector(SELECTORS.empty);
    const pagination = container.querySelector(SELECTORS.pagination);
    const countEl = document.querySelector(SELECTORS.count);
    const countMobileEl = document.querySelector(SELECTORS.countMobile);

    const heartTemplate = document.querySelector("[data-icon-heart-template]");
    const chevronTemplate = document.querySelector(
      "[data-icon-chevron-template]",
    );
    const checkTemplate = document.querySelector("[data-icon-check-template]");

    const cartTemplate = document.querySelector("[data-icon-cart-template]");
    const fireTemplate = document.querySelector("[data-icon-fire-template]");
    const leafTemplate = document.querySelector("[data-icon-leaf-template]");
    const seedlingTemplate = document.querySelector(
      "[data-icon-seedling-template]",
    );

    const heartSvg = heartTemplate ? heartTemplate.innerHTML.trim() : "";
    const chevronSvg = chevronTemplate ? chevronTemplate.innerHTML.trim() : "";
    const checkSvg = checkTemplate ? checkTemplate.innerHTML.trim() : "";
    const cartSvg = cartTemplate ? cartTemplate.innerHTML.trim() : "";
    const trophyTemplate = document.querySelector(
      "[data-icon-trophy-template]",
    );
    const fireSvg = fireTemplate ? fireTemplate.innerHTML.trim() : "";
    const leafSvg = leafTemplate ? leafTemplate.innerHTML.trim() : "";
    const seedlingSvg = seedlingTemplate
      ? seedlingTemplate.innerHTML.trim()
      : "";
    const trophySvg = trophyTemplate ? trophyTemplate.innerHTML.trim() : "";
    const circleXTemplate = document.querySelector(
      "[data-icon-circle-x-template]",
    );
    const circleXSvg = circleXTemplate ? circleXTemplate.innerHTML.trim() : "";

    let activeFilters = {};
    let lastFacets = {};
    let priceMin = "";
    let priceMax = "";

    const query = getQueryParam("q");
    const page = parseInt(getQueryParam("page"), 10) || 1;

    if (!query) {
      if (loading) loading.classList.add("hidden");
      return;
    }

    activeFilters = readFiltersFromUrl();
    initDrawer();
    initSortDropdowns();

    if (pagination) {
      pagination.addEventListener("click", (event) => {
        const link = event.target.closest("[data-algolia-page]");
        if (!link) return;
        event.preventDefault();
        const newPage = parseInt(link.getAttribute("data-algolia-page"), 10);
        setQueryParam("page", newPage);
        window.scrollTo({ top: 0, behavior: "smooth" });
        fetchResults(query, newPage - 1);
      });
    }

    fetchResults(query, page - 1);

    window.addEventListener("popstate", () => {
      activeFilters = readFiltersFromUrl();
      currentSort = getQueryParam("sort_by") || defaultSort;
      syncSortDropdowns(currentSort);
      const urlPage = parseInt(getQueryParam("page"), 10) || 1;
      fetchResults(query, urlPage - 1);
    });

    function syncSortDropdowns(value) {
      const dropdowns = document.querySelectorAll(SELECTORS.sortDropdowns);
      for (let i = 0; i < dropdowns.length; i++) {
        dropdowns[i].value = value;
      }
    }

    function initSortDropdowns() {
      const dropdowns = document.querySelectorAll(SELECTORS.sortDropdowns);
      if (currentSort !== defaultSort) {
        syncSortDropdowns(currentSort);
      }
      dropdowns.forEach((dropdown) => {
        dropdown.addEventListener("change", (event) => {
          currentSort = event.target.value;
          syncSortDropdowns(currentSort);
          setQueryParam("sort_by", currentSort);
          setQueryParam("page", "1");
          fetchResults(query, 0);
        });
      });
    }

    function getSearchIndex() {
      if (locale !== "de") {
        return productsIndex;
      }
      if (currentSort === "relevance" || !sortIndices[currentSort]) {
        return productsIndex;
      }
      return sortIndices[currentSort];
    }

    function algoliaSearch(queryStr, pageNum) {
      const url = `https://${appId}-dsn.algolia.net/1/indexes/*/queries`;

      const facetFilters = buildFacetFilters();

      let params =
        `query=${encodeURIComponent(queryStr)}` +
        `&hitsPerPage=${hitsPerPage}` +
        `&page=${pageNum}` +
        `&clickAnalytics=true` +
        `&facets=${encodeURIComponent("*")}`;

      if (facetFilters.length > 0) {
        params += `&facetFilters=${encodeURIComponent(JSON.stringify(facetFilters))}`;
      }

      const numericFilters = buildNumericFilters();
      if (numericFilters.length > 0) {
        params += `&numericFilters=${encodeURIComponent(JSON.stringify(numericFilters))}`;
      }

      return fetch(url, {
        method: "POST",
        headers: {
          "X-Algolia-Application-Id": appId,
          "X-Algolia-API-Key": apiKey,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          requests: [{ indexName: getSearchIndex(), params }],
        }),
      }).then((response) => {
        if (!response.ok) throw new Error(response.status);
        return response.json();
      });
    }

    function buildFacetFilters() {
      return Object.entries(activeFilters)
        .filter(([, values]) => values?.length > 0)
        .map(([facetName, values]) => values.map((v) => `${facetName}:${v}`));
    }

    function buildNumericFilters() {
      const filters = [];
      if (priceMin !== "") {
        filters.push(`price>=${priceMin}`);
      }
      if (priceMax !== "") {
        filters.push(`price<=${priceMax}`);
      }
      return filters;
    }

    function fetchResults(queryStr, pageNum) {
      if (loading) loading.classList.remove("hidden");
      if (grid) grid.innerHTML = "";
      if (empty) empty.classList.add("hidden");
      if (pagination) {
        pagination.classList.add("hidden");
        pagination.innerHTML = "";
      }

      algoliaSearch(queryStr, pageNum)
        .then((data) => {
          const result = data.results[0];
          if (!result) return;

          if (loading) loading.classList.add("hidden");

          const hits = result.hits || [];
          const totalHits = result.nbHits || 0;
          const totalPages = result.nbPages || 0;
          const currentPage = result.page || 0;

          lastFacets = result.facets || {};
          updateDrawerBody();

          updateResultsCount(totalHits, queryStr);

          if (hits.length === 0) {
            if (empty) empty.classList.remove("hidden");
            return;
          }

          renderGrid(hits);
          renderPagination(currentPage, totalPages, queryStr);
        })
        .catch(() => {
          if (loading) loading.classList.add("hidden");
          if (empty) empty.classList.remove("hidden");
        });
    }

    function updateResultsCount(totalHits, queryStr) {
      const els = [countEl, countMobileEl];
      els.forEach((el) => {
        if (!el) return;
        if (totalHits > 0) {
          const countRaw = (
            translations.results_count ||
            '__COUNT__ Ergebnisse für "__TERMS__" gefunden'
          )
            .replace("__COUNT__", totalHits)
            .replace("__TERMS__", queryStr)
            .replace("{{ count }}", totalHits)
            .replace("{{ terms }}", queryStr);
          const decoded = decodeEntities(countRaw);
          el.textContent = `(${decoded})`;
          el.classList.remove("hidden");
        } else {
          el.classList.add("hidden");
        }
      });
    }

    function renderGrid(hits) {
      let html =
        '<div class="grid grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-7 mt-5">';
      hits.forEach((hit) => {
        html += `<div>${buildGridCard(hit)}</div>`;
      });
      html += "</div>";
      if (grid) grid.innerHTML = html;
      initLazyEtrustedWidgets(grid);
      verifyAvailability(grid);
    }

    function initLazyEtrustedWidgets(parentEl) {
      if (etrustedObserver) {
        etrustedObserver.disconnect();
        etrustedObserver = null;
      }
      if (!parentEl || !("IntersectionObserver" in window)) return;

      const widgets = parentEl.querySelectorAll("[data-algolia-etrusted-lazy]");
      if (!widgets.length) return;

      etrustedObserver = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            observer.unobserve(entry.target);
            upgradeEtrustedWidget(entry.target);
          });
        },
        { rootMargin: "200px" },
      );

      widgets.forEach((widgetEl) => {
        etrustedObserver.observe(widgetEl);
      });
    }

    function upgradeEtrustedWidget(widgetEl) {
      if (!widgetEl) return;

      const handle = widgetEl.getAttribute("data-product-handle");
      const fallbackSku = widgetEl.getAttribute("data-fallback-sku") || "";
      if (!handle || !fallbackSku) return;

      getProductSkuList(handle).then((skuList) => {
        const finalSku = skuList || fallbackSku;
        if (!finalSku || widgetEl.firstChild) return;

        widgetEl.appendChild(buildEtrustedWidgetElement(finalSku));
      });
    }

    function getProductSkuList(handle) {
      if (!handle) return Promise.resolve("");
      if (productSkuCache.has(handle)) {
        return productSkuCache.get(handle);
      }

      const fetchUrl = buildStoreUrl(`/products/${handle}.js`);
      const request = fetch(fetchUrl)
        .then((response) => {
          if (!response.ok) throw new Error(response.status);
          return response.json();
        })
        .then((product) => {
          if (!product || !Array.isArray(product.variants)) return "";
          return product.variants
            .map((variant) => variant.sku)
            .filter(Boolean)
            .join(",");
        })
        .catch(() => "");

      productSkuCache.set(handle, request);
      return request;
    }

    function verifyAvailability(parentEl) {
      if (!parentEl) return;
      const cards = parentEl.querySelectorAll("[data-quick-atc-trigger]");
      const handles = [];
      const cardsByHandle = {};
      cards.forEach((btn) => {
        const handle = btn.getAttribute("data-product-handle");
        if (handle && !cardsByHandle[handle]) {
          handles.push(handle);
          cardsByHandle[handle] = btn.closest("article");
        }
      });

      handles.forEach((handle) => {
        fetch(buildStoreUrl(`/products/${handle}.js`))
          .then((res) => {
            return res.json();
          })
          .then((product) => {
            if (product.available) return;
            const card = cardsByHandle[handle];
            if (!card) return;

            const existingBadge = card.querySelector("[data-badge]");
            if (existingBadge) existingBadge.remove();

            const badgeHtml =
              `<div data-badge class="absolute top-2 left-2 lg:top-[18px] lg:left-[18px] z-20 flex items-center gap-1 px-2 py-1 rounded-full" style="background: #6b7280">` +
              `<span class="text-white">${
                circleXSvg
              }</span><span class="caption text-white">${
                translations.sold_out || "Ausverkauft"
              }</span></div>`;
            card.insertAdjacentHTML("afterbegin", badgeHtml);

            const btn = card.querySelector("[data-quick-atc-trigger]");
            if (btn) {
              btn.disabled = true;
              btn.classList.remove(
                "bg-accent",
                "text-primary",
                "active:scale-95",
                "active:bg-hover-primary",
                "lg:hover:bg-hover-primary",
              );
              btn.classList.add("cursor-not-allowed");
              btn.style.background = "#d1d5db";
              btn.style.color = "#6b7280";
            }
          })
          .catch(() => {});
      });
    }

    function formatMoney(price) {
      const num = parseFloat(price);
      const amountDot = num.toFixed(2);
      const amountComma = amountDot.replace(".", ",");
      return moneyFormat
        .replace("{{amount_with_comma_separator}}", amountComma)
        .replace(
          "{{amount_no_decimals_with_comma_separator}}",
          Math.round(num).toString(),
        )
        .replace("{{amount}}", amountDot)
        .replace("{{amount_no_decimals}}", Math.round(num).toString());
    }

    function buildStoreUrl(path) {
      const normalizedRoot =
        rootUrl && rootUrl !== "/" ? rootUrl.replace(/\/$/, "") : "";
      const normalizedPath = path.startsWith("/") ? path : `/${path}`;
      return `${normalizedRoot}${normalizedPath}`;
    }

    function getTagsLower(hit) {
      const tags = Array.isArray(hit.tags) ? hit.tags : [];
      return tags.map((tag) => String(tag).toLowerCase().trim());
    }

    function getBadgeTypeFromHit(hit) {
      const tagsLower = getTagsLower(hit);
      const inventoryQuantity = Number(hit.inventory_quantity);
      const hasInventoryQuantity = Number.isFinite(inventoryQuantity);
      const isSoldOut =
        hit.inventory_available === false ||
        (hasInventoryQuantity && inventoryQuantity <= 0);
      const isLowStock =
        !isSoldOut &&
        hasInventoryQuantity &&
        inventoryQuantity > 0 &&
        inventoryQuantity <= 20;

      return window.PeakBadges.resolveBadgeType({
        isSoldOut,
        isLowStock,
        isBestSeller: tagsLower.includes("bestseller"),
        hasHoheNachfrage:
          tagsLower.includes("hohe-nachfrage") ||
          tagsLower.includes("hohe nachfrage"),
        hasVegan: tagsLower.includes("vegan"),
        hasBio: tagsLower.includes("bio"),
      });
    }

    function buildBadgeHtml(badgeType) {
      const badgeClasses =
        "absolute top-2 left-2 lg:top-[18px] lg:left-[18px] z-20";

      if (badgeType === "sold-out") {
        return (
          `<div class="${badgeClasses} flex items-center gap-1 px-2 py-1 rounded-full" style="background: #6b7280">` +
          `<span class="text-white">${circleXSvg}</span><span class="caption text-white">${translations.sold_out || "Ausverkauft"}</span>` +
          `</div>`
        );
      }

      if (badgeType === "low-stock") {
        return (
          `<div class="${badgeClasses} flex items-center gap-1 px-2 py-1 rounded-full" style="background: #dc2626">` +
          `<span style="color: #fecaca">${fireSvg}</span><span class="caption text-white">${translations.badge_low_stock || "Bald ausverkauft"}</span>` +
          `</div>`
        );
      }

      if (badgeType === "best-seller") {
        return (
          `<div class="${badgeClasses} bg-accent flex items-center gap-1 px-2 py-1 rounded-full">` +
          `<span class="text-primary">${trophySvg}</span><span class="caption text-primary">${translations.badge_best_seller || "Bestseller"}</span>` +
          `</div>`
        );
      }

      if (badgeType === "hohe-nachfrage") {
        return (
          `<div class="${badgeClasses} bg-gradient-dark flex items-center gap-1 px-2 py-1 rounded-full">` +
          `${fireSvg}<span class="caption text-white">${translations.badge_high_demand || "Hohe Nachfrage"}</span>` +
          `</div>`
        );
      }

      if (badgeType === "vegan") {
        return (
          `<div class="${badgeClasses} flex items-center gap-1 px-2 py-1 rounded-full" style="background: #059669">` +
          `<span style="color: #a7f3d0">${seedlingSvg}</span><span class="caption text-white">${translations.badge_vegan}</span>` +
          `</div>`
        );
      }

      if (badgeType === "bio") {
        return (
          `<div class="${badgeClasses} flex items-center gap-1 px-2 py-1 rounded-full" style="background: #15803d">` +
          `<span style="color: #bbf7d0">${leafSvg}</span><span class="caption text-white">${translations.badge_bio}</span>` +
          `</div>`
        );
      }

      return "";
    }

    function buildEtrustedWidgetElement(sku) {
      const widget = document.createElement("etrusted-widget");
      widget.setAttribute(
        "data-etrusted-widget-id",
        "wdg-7dad729a-c376-426c-99db-109e7e8e9615",
      );
      widget.setAttribute("data-sku", sku);
      return widget;
    }

    function buildProductUrl(hit) {
      const url = buildStoreUrl(`/products/${hit.handle}`);
      return hit.objectID
        ? `${url}?variant=${encodeURIComponent(hit.objectID)}`
        : url;
    }

    function buildGridCard(hit) {
      const url = buildProductUrl(hit);
      const image = hit.image || "";
      const title = escapeHtml(hit.title || "");
      const price = hit.price || 0;
      const compareAtPrice = hit.compare_at_price || 0;
      const isOnSale = compareAtPrice > price && compareAtPrice > 0;
      const variants =
        hit.variants_count || (hit.variants ? hit.variants.length : 0);
      const optionNames = hit.options || {};
      let firstVariant = "";
      const optionKeys = Object.keys(optionNames);
      if (optionKeys.length > 0) {
        const val = optionNames[optionKeys[0]];
        if (typeof val === "string" && val) {
          firstVariant = val;
        } else if (Array.isArray(val) && val.length > 0) {
          firstVariant = val[0];
        }
      }

      const badgeType = getBadgeTypeFromHit(hit);
      const badgeHtml = buildBadgeHtml(badgeType);

      const wishlistLabel =
        translations.add_to_wishlist || "Zur Wunschliste hinzufügen";
      const wishlistHtml = heartSvg
        ? `<button type="button" class="st-wishlist-button absolute top-2 right-2 z-10 text-primary hover:text-discount transition-colors" aria-label="${wishlistLabel}" data-type="product-card" data-handle="${hit.handle}">${heartSvg.replace('width="24"', 'class="w-6 h-6" width="24"')}</button>`
        : "";

      let variantPillsHtml = "";
      if (variants > 1) {
        const remaining = variants - 1;
        const moreLabel = (
          translations.more_variants_full || "+__COUNT__ Sorten"
        ).replace("__COUNT__", remaining);
        const flavoursLabel = (
          translations.flavours_count || "__COUNT__ Geschmäcker"
        ).replace("__COUNT__", variants);
        variantPillsHtml =
          `<span class="caption text-subdued px-2 py-[3px] rounded-full bg-white whitespace-nowrap lg:hidden">${flavoursLabel}</span>` +
          `<div class="hidden lg:block overflow-visible w-full">` +
          `<div class="flex items-center">${
            firstVariant
              ? `<span class="shrink-0 mr-[5px] caption text-subdued px-2 py-[3px] rounded-full bg-bg-gray lg:bg-white whitespace-nowrap">${escapeHtml(firstVariant)}</span>`
              : ""
          }<span class="shrink-0 mr-[5px] caption text-subdued px-2 py-[3px] rounded-full bg-bg-gray lg:bg-white whitespace-nowrap">${moreLabel}</span>` +
          `</div></div>`;
      }

      let priceHtml = `<p class="body-small lg:body font-bold ${
        isOnSale ? "text-discount" : ""
      }">${formatMoney(price)}</p>`;
      if (isOnSale) {
        priceHtml += `<p class="body-small lg:body font-light line-through">${formatMoney(
          compareAtPrice,
        )}</p>`;
      }

      const imgSrc = image ? `${image.replace(/\?.*$/, "")}?width=1200` : "";
      const imgHtml = imgSrc
        ? `<img src="${imgSrc}" loading="lazy" sizes="(min-width: 1024px) 25vw, (min-width: 640px) 33vw, 50vw" class="w-full h-[80%] object-contain" alt="">`
        : '<div class="w-full h-full bg-bg-gray"></div>';

      const atcLabel = translations.add_to_cart || "In den Warenkorb";
      const cartIcon = cartSvg
        ? cartSvg.replace(/<svg /, '<svg class="w-5 h-5 lg:w-6 lg:h-6" ')
        : "";
      const atcBtnClasses =
        badgeType === "sold-out"
          ? "cursor-not-allowed"
          : "bg-accent text-primary active:scale-95 active:bg-hover-primary lg:hover:bg-hover-primary";
      const atcBtnStyle =
        badgeType === "sold-out"
          ? ' style="background: #d1d5db; color: #6b7280"'
          : "";
      const atcHtml = cartIcon
        ? `<div class="absolute -bottom-2 -right-2 z-10 p-1.5">` +
          `<button type="button" class="w-9 h-9 lg:w-12 lg:h-12 flex items-center justify-center rounded-tl-2xl ${atcBtnClasses} transition-all z-20"` +
          `${atcBtnStyle}${badgeType === "sold-out" ? " disabled" : ""}` +
          ` data-quick-atc-trigger` +
          ` data-product-handle="${hit.handle}"` +
          ` data-product-url="${url}"` +
          ` aria-label="${atcLabel}"` +
          `>${cartIcon}</button></div>`
        : "";

      const sku =
        hit.variants && hit.variants.length
          ? hit.variants
              .map((variant) => variant.sku)
              .filter(Boolean)
              .join(",")
          : hit.sku || "";
      const needsLazyEtrustedUpgrade =
        !(
          hit.variants &&
          hit.variants.length &&
          hit.variants.some((variant) => variant && variant.sku)
        ) &&
        Boolean(hit.handle) &&
        Boolean(hit.sku) &&
        variants > 1;
      const etrustedInnerHtml = needsLazyEtrustedUpgrade
        ? `<div data-algolia-etrusted-lazy data-product-handle="${escapeAttr(
            hit.handle,
          )}" data-fallback-sku="${escapeAttr(hit.sku)}"></div>`
        : `<etrusted-widget data-etrusted-widget-id="wdg-7dad729a-c376-426c-99db-109e7e8e9615" data-sku="${escapeAttr(sku)}"></etrusted-widget>`;
      const etrustedHtml = sku
        ? `<div class="origin-top-left scale-[0.70] lg:scale-[0.85] h-[20px] lg:h-auto">${etrustedInnerHtml}</div>`
        : "";

      const subtitleRaw =
        (hit.meta && hit.meta.custom && hit.meta.custom.product_subtitle) ||
        (hit.metafields &&
          hit.metafields.custom &&
          hit.metafields.custom.product_subtitle) ||
        "";
      const subtitle =
        typeof subtitleRaw === "object" && subtitleRaw !== null
          ? subtitleRaw[locale] || subtitleRaw.value || ""
          : subtitleRaw;
      const subtitleHtml = subtitle
        ? `<p class="caption line-clamp-2">${escapeHtml(subtitle)}</p>`
        : "";

      return (
        `<article class="product-card bg-bg-gray px-2 py-1.5 rounded-2xl relative flex flex-col h-full group overflow-clip lg:hover:bg-smoky-black/10 transition-colors gap-2 lg:bg-bg-gray lg:rounded-md lg:gap-4 lg:p-[13px]">` +
        `${badgeHtml}` +
        `<div class="bg-white relative aspect-[4/5] overflow-hidden rounded-lg lg:rounded-md">` +
        `<a href="${url}" class="w-full h-full flex items-center justify-center" tabindex="-1" aria-hidden="true">${imgHtml}</a>` +
        `${wishlistHtml}${atcHtml}</div>` +
        `<div class="product-card__content flex flex-col items-start gap-2 lg:gap-[13px] w-full flex-1">` +
        `<div class="flex flex-col items-start gap-1 lg:gap-[5px] w-full">` +
        `${etrustedHtml}` +
        `<h2 class="product-card__title body-small lg:body font-semibold">` +
        `<a href="${url}" class="after:absolute after:inset-0">${title}</a>` +
        `</h2>` +
        `${subtitleHtml}</div>` +
        `${variantPillsHtml}` +
        `<div class="product-card__price pb-1 flex gap-1.5 lg:gap-2 items-baseline flex-wrap mt-auto">${priceHtml}</div>` +
        `</div>` +
        `</article>`
      );
    }

    function renderPagination(currentPage, totalPages, queryStr) {
      if (totalPages <= 1 || !pagination) return;

      const pages = getPageRange(currentPage, totalPages);
      let html = "";

      if (currentPage > 0) {
        const prevUrl = buildPageUrl(queryStr, currentPage);
        const prevLabel = translations.pagination_previous || "Vorherige Seite";
        html +=
          `<a href="${prevUrl}" class="w-10 h-10 flex items-center justify-center rounded-full border-2 border-primary hover:bg-bg-gray transition-colors" aria-label="${prevLabel}" data-algolia-page="${currentPage}">` +
          `<span class="w-3 h-3 rotate-180 inline-flex">${chevronSvg}</span></a>`;
      }

      pages.forEach((p) => {
        if (p === "...") {
          html +=
            '<span class="body w-10 h-10 flex items-center justify-center">\u2026</span>';
        } else if (p === currentPage) {
          html += `<span class="body font-bold w-10 h-10 flex items-center justify-center bg-accent rounded-full" aria-current="page">${
            p + 1
          }</span>`;
        } else {
          const pageUrl = buildPageUrl(queryStr, p + 1);
          html += `<a href="${pageUrl}" class="body w-10 h-10 flex items-center justify-center rounded-full hover:bg-bg-gray transition-colors" data-algolia-page="${
            p + 1
          }">${p + 1}</a>`;
        }
      });

      if (currentPage < totalPages - 1) {
        const nextUrl = buildPageUrl(queryStr, currentPage + 2);
        const nextLabel = translations.pagination_next || "Nächste Seite";
        html += `<a href="${nextUrl}" class="w-10 h-10 flex items-center justify-center rounded-full border-2 border-primary hover:bg-bg-gray transition-colors" aria-label="${nextLabel}" data-algolia-page="${
          currentPage + 2
        }"><span class="w-3 h-3 inline-flex">${chevronSvg}</span></a>`;
      }

      pagination.innerHTML = html;
      pagination.classList.remove("hidden");
      pagination.classList.add("flex");
    }

    function getPageRange(current, total) {
      if (total <= 7) {
        return Array.from({ length: total }, (_, i) => i);
      }

      const pages = [0];

      if (current > 2) pages.push("...");

      for (
        let i = Math.max(1, current - 1);
        i <= Math.min(total - 2, current + 1);
        i++
      ) {
        if (!pages.includes(i)) pages.push(i);
      }

      if (current < total - 3) pages.push("...");
      if (!pages.includes(total - 1)) pages.push(total - 1);

      return pages;
    }

    function buildPageUrl(queryStr, pageNum) {
      const url = new URL(window.location.href);
      url.searchParams.set("q", queryStr);
      url.searchParams.set("page", pageNum);
      return url.pathname + url.search;
    }

    function initDrawer() {
      const toggleBtns = document.querySelectorAll(SELECTORS.filtersToggle);
      const drawer = document.querySelector(SELECTORS.filtersDrawer);
      const backdrop = document.querySelector(SELECTORS.filtersBackdrop);
      const closeBtn = document.querySelector(SELECTORS.filtersClose);
      const applyBtn = document.querySelector(SELECTORS.filtersApply);
      const resetBtn = document.querySelector(SELECTORS.filtersReset);

      if (!drawer) return;

      function openDrawer() {
        drawer.classList.remove("translate-x-full");
        backdrop.classList.remove("opacity-0", "pointer-events-none");
        backdrop.classList.add("opacity-100");
        document.body.style.overflow = "hidden";
      }

      function closeDrawer() {
        drawer.classList.add("translate-x-full");
        backdrop.classList.add("opacity-0", "pointer-events-none");
        backdrop.classList.remove("opacity-100");
        document.body.style.overflow = "";
      }

      toggleBtns.forEach((btn) => {
        btn.addEventListener("click", openDrawer);
      });
      if (closeBtn) closeBtn.addEventListener("click", closeDrawer);
      if (backdrop) backdrop.addEventListener("click", closeDrawer);

      if (applyBtn) {
        applyBtn.addEventListener("click", () => {
          readFiltersFromDrawer();
          closeDrawer();
          syncFiltersToUrl();
          fetchResults(query, 0);
        });
      }

      if (resetBtn) {
        resetBtn.addEventListener("click", () => {
          activeFilters = {};
          priceMin = "";
          priceMax = "";
          updateDrawerBody();
          closeDrawer();
          syncFiltersToUrl();
          fetchResults(query, 0);
        });
      }

      drawer.addEventListener("click", (event) => {
        const toggle = event.target.closest("[data-algolia-accordion-toggle]");
        if (!toggle) return;

        const targetId = toggle.getAttribute("aria-controls");
        const content = document.getElementById(targetId);
        const icon = toggle.querySelector("[data-algolia-accordion-icon]");
        if (!content) return;

        const isOpen = toggle.getAttribute("aria-expanded") === "true";
        toggle.setAttribute("aria-expanded", String(!isOpen));
        content.classList.toggle("hidden");
        if (icon) {
          icon.classList.toggle("-rotate-90", !isOpen);
          icon.classList.toggle("rotate-90", isOpen);
        }
      });
    }

    function readFiltersFromDrawer() {
      activeFilters = {};
      const body = document.querySelector(SELECTORS.filtersBody);
      if (!body) return;

      const checkboxes = body.querySelectorAll(
        "input[type='checkbox']:checked",
      );
      checkboxes.forEach((cb) => {
        const facetName = cb.getAttribute("data-facet-name");
        const facetValue = cb.getAttribute("data-facet-value");
        if (!facetName || !facetValue) return;
        if (!activeFilters[facetName]) {
          activeFilters[facetName] = [];
        }
        activeFilters[facetName].push(facetValue);
      });

      const minInput = body.querySelector("[data-algolia-price-min]");
      const maxInput = body.querySelector("[data-algolia-price-max]");
      priceMin = minInput ? minInput.value.trim() : "";
      priceMax = maxInput ? maxInput.value.trim() : "";
    }

    function getVisibleFacets() {
      const facetLabels = translations.facet_labels || {};
      const facets = [];
      FACET_ATTRIBUTES.forEach((attribute) => {
        const values = lastFacets[attribute];
        if (!values || Object.keys(values).length < 2) return;
        facets.push({
          name: attribute,
          label: facetLabels[attribute] || attribute,
          values,
        });
      });
      return facets;
    }

    function updateDrawerBody() {
      const body = document.querySelector(SELECTORS.filtersBody);
      if (!body) return;

      let html = "";

      const sortLabel = translations.sort_by || "Sortieren nach";
      const relevanceLabel = translations.sort_relevance || "Relevanz";

      html += '<div class="border-b border-primary/20 px-6">';
      html +=
        `<button type="button" class="flex items-center justify-between w-full py-4" data-algolia-accordion-toggle aria-expanded="false" aria-controls="algolia-filter-sort">` +
        `<div class="flex items-center gap-2">` +
        `<span class="body font-bold">${sortLabel}</span>` +
        `<span class="body text-subdued">${relevanceLabel}</span>` +
        `</div>` +
        `<span class="transition-transform duration-200 rotate-90" data-algolia-accordion-icon>${chevronSvg}</span>` +
        `</button>`;
      html +=
        '<div id="algolia-filter-sort" class="hidden pb-4">' +
        '<label class="flex items-center gap-3 py-2 cursor-pointer">' +
        `<input type="radio" name="sort_by" value="relevance" ${currentSort === "relevance" ? "checked" : ""} class="peer sr-only">` +
        '<span class="w-5 h-5 rounded-full border-2 border-primary flex items-center justify-center peer-checked:hidden"></span>' +
        '<span class="w-5 h-5 rounded-full border-2 border-primary items-center justify-center hidden peer-checked:flex">' +
        '<span class="w-2.5 h-2.5 rounded-full bg-primary"></span>' +
        "</span>" +
        `<span class="body">${relevanceLabel}</span>` +
        "</label></div></div>";

      const priceLabel = translations.facet_price || "Preis";
      const priceHasActive = priceMin !== "" || priceMax !== "";
      html += '<div class="border-b border-primary/20 px-6">';
      html +=
        `<button type="button" class="flex items-center justify-between w-full py-4" data-algolia-accordion-toggle aria-expanded="${priceHasActive}" aria-controls="algolia-filter-price">` +
        `<div class="flex items-center gap-2">` +
        `<span class="body font-bold">${priceLabel}</span>` +
        `</div>` +
        `<span class="transition-transform duration-200 ${priceHasActive ? "-rotate-90" : "rotate-90"}" data-algolia-accordion-icon>${chevronSvg}</span>` +
        `</button>`;
      html +=
        `<div id="algolia-filter-price" class="${priceHasActive ? "" : "hidden"} pb-4">` +
        '<div class="flex items-center gap-3">' +
        '<div class="flex-1"><div class="relative">' +
        '<span class="absolute left-3 top-1/2 -translate-y-1/2 body text-subdued">\u20AC</span>' +
        `<input type="number" data-algolia-price-min value="${escapeAttr(priceMin)}" min="0" placeholder="Min" class="w-full rounded-sm border-2 border-primary/20 py-2 pl-8 pr-3 body focus:border-accent focus:outline-none">` +
        "</div></div>" +
        '<span class="body text-subdued">\u2013</span>' +
        '<div class="flex-1"><div class="relative">' +
        '<span class="absolute left-3 top-1/2 -translate-y-1/2 body text-subdued">\u20AC</span>' +
        `<input type="number" data-algolia-price-max value="${escapeAttr(priceMax)}" min="0" placeholder="Max" class="w-full rounded-sm border-2 border-primary/20 py-2 pl-8 pr-3 body focus:border-accent focus:outline-none">` +
        "</div></div>" +
        "</div></div></div>";

      const facets = getVisibleFacets();

      facets.forEach((facet, index) => {
        const { label } = facet;
        const activeValues = activeFilters[facet.name] || [];
        const hasActive = activeValues.length > 0;
        const facetId = `algolia-filter-${index}`;

        html += '<div class="border-b border-primary/20 px-6">';
        html +=
          `<button type="button" class="flex items-center justify-between w-full py-4" data-algolia-accordion-toggle aria-expanded="${hasActive}" aria-controls="${facetId}">` +
          `<div class="flex items-center gap-2">` +
          `<span class="body font-bold">${label}</span>`;

        if (hasActive) {
          html += `<span class="w-5 h-5 rounded-full bg-accent text-primary text-xs font-bold flex items-center justify-center">${activeValues.length}</span>`;
        }

        html +=
          `</div>` +
          `<span class="transition-transform duration-200 ${hasActive ? "-rotate-90" : "rotate-90"}" data-algolia-accordion-icon>${chevronSvg}</span>` +
          `</button>`;

        html += `<div id="${facetId}" class="${hasActive ? "" : "hidden"} pb-4">`;

        const sortedValues = Object.keys(facet.values).sort(
          (a, b) => facet.values[b] - facet.values[a],
        );

        sortedValues.forEach((value) => {
          const count = facet.values[value];
          const isChecked = activeValues.includes(value);
          const displayLabel = escapeHtml(value);

          html +=
            '<label class="flex items-center gap-3 py-2 cursor-pointer">' +
            `<input type="checkbox" data-facet-name="${facet.name}" data-facet-value="${escapeAttr(value)}" ${isChecked ? "checked" : ""} class="peer sr-only">` +
            `<span class="w-6 h-6 rounded-sm border-2 border-primary flex items-center justify-center peer-checked:hidden shrink-0"></span>` +
            `<span class="w-6 h-6 rounded-sm bg-accent border-2 border-accent items-center justify-center hidden peer-checked:flex shrink-0">${checkSvg.replace("<svg", '<svg class="w-4 h-4 text-white"')}</span>` +
            `<span class="body flex-1">${displayLabel}</span>` +
            `<span class="body text-subdued">(${count})</span>` +
            "</label>";
        });

        html += "</div></div>";
      });

      body.innerHTML = html;
    }

    function readFiltersFromUrl() {
      const filters = {};
      const params = new URLSearchParams(window.location.search);
      params.forEach((value, key) => {
        if (key.startsWith("filter.")) {
          const facetName = key.replace("filter.", "");
          filters[facetName] = value.split(",").filter(Boolean);
        }
      });
      priceMin = params.get("price_min") || "";
      priceMax = params.get("price_max") || "";
      return filters;
    }

    function syncFiltersToUrl() {
      const url = new URL(window.location.href);
      [...url.searchParams.keys()]
        .filter(
          (key) =>
            key.startsWith("filter.") ||
            key === "price_min" ||
            key === "price_max",
        )
        .forEach((key) => url.searchParams.delete(key));
      url.searchParams.set("page", "1");
      for (const [facetName, values] of Object.entries(activeFilters)) {
        if (values?.length > 0) {
          url.searchParams.set(`filter.${facetName}`, values.join(","));
        }
      }
      if (priceMin !== "") {
        url.searchParams.set("price_min", priceMin);
      }
      if (priceMax !== "") {
        url.searchParams.set("price_max", priceMax);
      }
      window.history.pushState({}, "", url.pathname + url.search);
    }

    function decodeEntities(str) {
      const entities = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'",
        "&apos;": "'",
      };
      return str.replace(
        /&(?:amp|lt|gt|quot|#39|apos);/g,
        (match) => entities[match] || match,
      );
    }

    function escapeHtml(str) {
      const div = document.createElement("div");
      div.textContent = str;
      return div.innerHTML;
    }

    function escapeAttr(str) {
      return str
        .replace(/&/g, "&amp;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#39;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;");
    }
  }

  function getQueryParam(name) {
    const params = new URLSearchParams(window.location.search);
    return params.get(name) || "";
  }

  function setQueryParam(name, value) {
    const url = new URL(window.location.href);
    url.searchParams.set(name, value);
    window.history.pushState({}, "", url.pathname + url.search);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
 